import { ChevronRightIcon, TimeIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Grid,
  GridItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Text,
  useDisclosure,
  useMediaQuery,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import FetchData from "../../services/FetchData";

export default function DetailTransaction({ isOpen, onClose, data }) {
  const [mobile] = useMediaQuery("(max-width: 600px)");

  var IDRConvert = Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
  });

  // console.log(data);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader textAlign="center">Detail Transaksi</ModalHeader>
        <ModalCloseButton />
        <hr />
        <ModalBody>
          <Text
            fontWeight="600"
            fontSize="16"
            display="flex"
            alignItems="center"
            py="3"
          >
            {data?.order_status === "Gagal"
              ? "Gagal (Expired)"
              : data?.order_status}
          </Text>
          <hr style={{ borderTop: "1px dashed #E0E0E0" }} />
          <Grid templateColumns="repeat(3, 1fr)" py="5" rowGap={2}>
            {/* <GridItem display="flex">
              <Text fontWeight="400" fontSize="12" color="#4E4E4E">
                No. Invoice
              </Text>
            </GridItem>
            <GridItem colSpan={2} display="flex" justifyContent="flex-end">
              <Text fontWeight="600" fontSize="16" color="#2563EB">
                203032393123932
              </Text>
            </GridItem> */}
            <GridItem display="flex">
              <Text fontWeight="400" fontSize="12" color="#4E4E4E">
                Tanggal Pembelian
              </Text>
            </GridItem>
            <GridItem colSpan={2} display="flex" justifyContent="flex-end">
              <Text fontWeight="400" fontSize="12">
                {data?.order_date}
              </Text>
            </GridItem>
          </Grid>
        </ModalBody>
        <hr />
        <ModalBody>
          <SimpleGrid columns={2}>
            <Text
              fontWeight="600"
              fontSize="16"
              display="flex"
              alignItems="center"
            >
              Detail Produk
            </Text>
            {/* <Box display="flex" justifyContent="end">
              <Button
                rightIcon={<ChevronRightIcon />}
                variant="ghost"
                fontWeight
              >
                UD. Materiam Bumi
              </Button>
            </Box> */}
          </SimpleGrid>
          {data?.items.map((item, key) => (
            <Grid
              key={key}
              templateColumns="repeat(3, 1fr)"
              borderRadius="10px"
              border="1px solid #E0E0E0"
              p={mobile ? "2" : "5"}
              my="3"
            >
              <GridItem colSpan={2} display="flex">
                <img
                  src={item.img}
                  alt={item.name}
                  style={{
                    borderRadius: "5px",
                    maxWidth: mobile ? "70px" : "100px",
                  }}
                />
                <Box
                  display="flex"
                  flexDir="column"
                  justifyContent="center"
                  pl="3"
                >
                  <Text fontWeight="500" fontSize={mobile ? "12" : "15"}>
                    {item.name}
                  </Text>
                  <Text fontWeight="400" fontSize={mobile ? "10" : "12"}>
                    {item.qty} Barang
                  </Text>
                </Box>
              </GridItem>
              <GridItem display="flex">
                <Box
                  hidden={mobile}
                  border="1px solid #E0E0E0"
                  my={mobile ? "2" : "5"}
                />
                <Box
                  display="flex"
                  justifyContent="end"
                  alignItems="center"
                  py={mobile ? "3" : "5"}
                  w="full"
                >
                  <Box fontSize={mobile ? "12" : "16"}>
                    <Text fontWeight="400">Total Harga</Text>
                    <Text fontWeight="600">
                      {IDRConvert.format(item.subtotal)}
                    </Text>
                  </Box>
                </Box>
              </GridItem>
            </Grid>
          ))}
        </ModalBody>
        <hr />
        <ModalBody>
          <Text
            fontWeight="600"
            fontSize="16"
            display="flex"
            alignItems="center"
          >
            Rincian Pembayaran
          </Text>
          <Grid templateColumns="repeat(2, 1fr)" py={2} rowGap={1}>
            <GridItem display="flex">
              <Text fontWeight="400" fontSize="14" color="#4E4E4E">
                Metode Pembayaran
              </Text>
            </GridItem>
            <GridItem display="flex" justifyContent="flex-end">
              <Text fontSize="14">{data?.payment_method}</Text>
            </GridItem>
            {/* <GridItem display="flex">
              <Text fontWeight="400" fontSize="14" color="#4E4E4E">
                Pajak
              </Text>
            </GridItem>
            <GridItem display="flex" justifyContent="flex-end">
              <Text fontWeight="400" fontSize="14">
                {IDRConvert.format(data?.tax_total)}
              </Text>
            </GridItem> */}
            <GridItem display="flex">
              <Text fontWeight="400" fontSize="14" color="#4E4E4E">
                Total Harga
              </Text>
            </GridItem>
            <GridItem display="flex" justifyContent="flex-end">
              <Text fontWeight="400" fontSize="14">
                {IDRConvert.format(data?.grand_total)}
              </Text>
            </GridItem>
          </Grid>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
